import { UrlObject } from "url";
import Image from "components/atoms/Image";
import { breakPoint } from "lib/constants";
import Link from "next/link";
import React, { VFC } from "react";
import styled from "styled-components";
import { pagesPath } from "faqSrc/lib/$path";

interface Props {
  logoUrl: string;
  mainTitle: string;
  mainTitleUrl: UrlObject;
  subTitle: string;
  subTitleUrl?: UrlObject;
}

const LogoAndMultiTitle: VFC<Props> = ({
  logoUrl,
  mainTitle,
  mainTitleUrl,
  subTitle,
  subTitleUrl,
}) => {
  return (
    <LogoTitleWrap>
      <Link href={pagesPath.$url()} passHref>
        <ImageLink aria-label={mainTitle}>
          <Image
            src={logoUrl}
            width="28"
            height="28"
            alt={mainTitle}
            display="grid"
          />
        </ImageLink>
      </Link>
      <div className="limited-line--1">
        <Link href={mainTitleUrl} passHref>
          <a>
            <MainTitle>{mainTitle}</MainTitle>
          </a>
        </Link>
        {subTitleUrl ? (
          <Link href={subTitleUrl} passHref>
            <HeaderLink>
              <SubTitle>{subTitle}</SubTitle>
            </HeaderLink>
          </Link>
        ) : (
          <SubTitle>{subTitle}</SubTitle>
        )}
      </div>
    </LogoTitleWrap>
  );
};

const MainTitle = styled.span`
  font-size: 22px;
  line-height: 36px;
  font-weight: 700;
  color: var(--pri-clr500);
`;

const SubTitle = styled.span`
  font-size: 18px;
  line-height: 30px;
  font-weight: 700;
  margin-left: 16px;
`;

const HeaderLink = styled.a`
  color: var(--body-clr);
  cursor: pointer;

  &:hover ${SubTitle} {
    text-decoration: underline;
  }
`;

const LogoTitleWrap = styled.div`
  display: grid;
  grid-template-columns: 40px auto;
  gap: 16px;
  justify-content: start;
  align-items: center;

  @media only screen and (max-width: ${breakPoint["xs"]}) {
    grid-template-columns: 40px auto;
    gap: 12px;
  }
`;

const ImageLink = styled.a`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export default LogoAndMultiTitle;
